export const CTypesMdkInput = {
    TEXT: "text",
    EMAIL: "email",
    NUMBER: "number"
} as const

export const CTransformTypeMdkInput = {
    NONE: 'none',
    LOWERCASE: 'lowercase',
    UPPERCASE: 'uppercase',
} as const

export const INPUT_MASK_REGEX: RegExp = /\(|\)|\d/g;
export const INPUT_ALLOWED_CHAR_REGEX = /^[a-zA-Z0-9 ]$/;
export const INPUT_ONLY_NUMBER_REGEX = /[0-9]/
export const INPUT_CONTROLS_REGEX = /^(Backspace|Delete|ArrowLeft|ArrowRight|Tab|Escape|Enter)$/